import React from 'react';
import { Box, Container, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import uomLogo from '../assets/Images/uom_logo.png';
import cselogo from '../assets/Images/cse_logo.png';

const Footer = () => {
  return (
    <Box
      component='footer'
      sx={{
        display: { md: 'flex' },
        justifyContent: 'center',
        width: '100%',
        py: 3,
        px: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container
        maxWidth='sm'
        align='center'
        sx={{ marginY: 'auto', marginBottom: 2, marginTop: 2 }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 40,
            marginBottom: 20,
          }}
        >
          <img
            src={uomLogo}
            alt='UOM Logo'
            style={{ width: '100%', maxWidth: 100, height: 'auto' }}
          />
          <img
            src={cselogo}
            alt='CSE Logo'
            style={{ width: '100%', maxWidth: 100, height: 'auto' }}
          />
        </div>
        <Typography
          variant='body1'
          align='center'
          color='text.secondary'
          sx={{
            fontWeight: 'bold',
            maxWidth: '70%',
            margin: 'auto',
            textAlign: 'center',
          }}
        >
          The Conference at the Department of Computer Science and
          Engineering, Faculty of Engineering, University of Moratuwa, is a prestigious annual event.
        </Typography>
      </Container>

      <Container
        maxWidth='sm'
        sx={{
          marginY: 'auto',
          marginBottom: 2,
          marginTop: 2,
          paddingRight: 4,
          paddingLeft: 4,
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        <Typography
          variant='h6'
          color='text.secondary'
          sx={{ fontWeight: 'bold', marginBottom: '10px' }}
        >
          Quick Links
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          <ul style={{ listStyleType: 'none', paddingLeft: '0', margin: '0' }}>
            <li style={{ marginLeft: '0', marginBottom: '6px' }}>
              <Link color='inherit' href='https://uom.lk/'>
                University of Moratuwa
              </Link>
            </li>
            <li style={{ marginLeft: '0', marginBottom: '6px' }}>
              <Link color='inherit' href='https://cse.mrt.ac.lk/'>
                Department of Computer Science & Engineering
              </Link>
            </li>
            <li style={{ marginLeft: '0', marginBottom: '6px' }}>
              <Link color='inherit' href='https://connect.cse.uom.lk/'>
                Careers Day
              </Link>
            </li>
          </ul>
        </Typography>
      </Container>

      <Container
        maxWidth='sm'
        sx={{
          marginY: 'auto',
          marginBottom: 2,
          marginTop: 2,
          paddingRight: 4,
          paddingLeft: 4,
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        <Typography
          variant='h6'
          color='text.secondary'
          sx={{ fontWeight: 'bold', marginBottom: '10px' }}
        >
          Contact Us
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Department of Computer Science & Engineering, <br />
          Faculty of Engineering, <br />
          University of Moratuwa, <br />
          Katubedda, Moratuwa, <br />
          Sri Lanka. <br />
          <br />
          Email:{' '}
          <Link color='inherit' href='adscai@cse.mrt.ac.lk'>
            adscai@cse.mrt.ac.lk
          </Link>{' '}
          <br />
          Phone: +94 11 264 0380/2
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, marginTop: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
          <IconButton
            component={Link}
            href='https://www.facebook.com/cse.uom.lk/'
            target='_blank'
            color='inherit'
            aria-label='Facebook'
            sx={{ color: 'text.secondary' }}
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            component={Link}
            href='https://x.com/cse_uom'
            target='_blank'
            color='inherit'
            aria-label='Twitter'
            sx={{ color: 'text.secondary' }}

          >
            <TwitterIcon />
          </IconButton>
          <IconButton
            component={Link}
            href='https://www.instagram.com/cse.uom/'
            target='_blank'            
            color='inherit'
            aria-label='Instagram'
            sx={{ color: 'text.secondary' }}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            component={Link}
            href='https://lk.linkedin.com/company/department-of-computer-science-engineering-university-of-moratuwa'
            target='_blank'            
            color='inherit'
            aria-label='LinkedIn'
            sx={{ color: 'text.secondary' }}
          >
            <LinkedInIcon />
          </IconButton>
        </Box>
      </Container>

      {/* <Container maxWidth='sm'>
        <Typography variant='body1'>
          My sticky footer can be found here.
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          {'Copyright © '}
          <Link color='inherit' href='https://your-website.com/'>
            Your Website
          </Link>{' '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
      </Container> */}
    </Box>
  );
};

export default Footer;
